import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Compass, SignOut, User as UserIcon, List } from "@phosphor-icons/react";
import MobileMenu from "@/components/MobileMenu";
const COUNTRY_CODES = {
  india: "in",
  "united arab emirates": "ae",
  uae: "ae",
  "u.a.e": "ae",
  usa: "us",
  "united states": "us",
  "united states of america": "us",
  uk: "gb",
  "united kingdom": "gb",
  britain: "gb",
  "saudi arabia": "sa",
  qatar: "qa",
  kuwait: "kw",
  bahrain: "bh",
  oman: "om",
  canada: "ca",
  australia: "au",
  singapore: "sg",
  germany: "de",
  france: "fr",
  netherlands: "nl",
  ireland: "ie",
  "new zealand": "nz",
  "south africa": "za",
  malaysia: "my",
  japan: "jp",
};

const getCountryCode = (country) => {
  const key = String(country || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

  return COUNTRY_CODES[key] || null;
};

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  const onLanding = pathname === "/";

  return (
    <>
      <nav className="fixed top-0 w-full z-50 glass border-b border-white/10" data-testid="navbar">
        <div className="px-4 sm:px-6 md:px-12 lg:px-24 h-16 flex items-center justify-between max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 min-w-0" data-testid="logo-link">
            <Compass size={26} weight="duotone" className="text-blue-500 shrink-0" />
            <span className="font-medium tracking-tight text-base sm:text-lg truncate">
              Career GPS <span className="text-blue-500">AI</span>
            </span>
          </Link>
          <div className="flex items-center gap-1 sm:gap-2">
            {onLanding && (
              <>
                <a href="#features" className="hidden sm:block text-sm text-zinc-400 hover:text-white px-3 py-2 min-h-[44px] flex items-center" data-testid="nav-features">Features</a>
                <a href="#pricing" className="hidden sm:block text-sm text-zinc-400 hover:text-white px-3 py-2 min-h-[44px] items-center" data-testid="nav-pricing">Pricing</a>
                <Link to="/contact" className="hidden sm:block text-sm text-zinc-400 hover:text-white px-3 py-2 min-h-[44px] items-center" data-testid="nav-contact">Contact</Link>
              </>
            )}
            {user ? (
              <>
       
            <Link
  to="/dashboard"
  className="text-sm text-zinc-300 hover:text-white px-3 py-2 rounded-lg"
>
  Dashboard
</Link>

<Link
  to="/profile"
  className="inline-flex items-center gap-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 px-2 sm:px-3 py-2 rounded-lg"
>
  <UserIcon size={16} />

  <span className="hidden md:inline truncate max-w-[160px]">
    {user.name || user.email}
  </span>

  <span
  className="inline-flex h-5 w-7 overflow-hidden rounded-sm border border-white/10"
  title={user?.profile?.country || "Country"}
>
  {getCountryCode(user?.profile?.country || user?.country) ? (
    <img
      src={`https://flagcdn.com/w40/${getCountryCode(
        user?.profile?.country || user?.country
      )}.png`}
      alt={user?.profile?.country || "Country"}
      className="h-full w-full object-cover"
    />
  ) : (
    <span className="text-sm">🌍</span>
  )}
</span>
</Link>                
                <button onClick={onLogout} className="text-zinc-400 hover:text-white w-11 h-11 inline-flex items-center justify-center" data-testid="nav-logout" aria-label="Log out">
                  <SignOut size={18} />
                </button>
                {/* Mobile hamburger — only when authed */}
                <button
                  onClick={() => setMenuOpen(true)}
                  className="lg:hidden w-11 h-11 inline-flex items-center justify-center text-zinc-300 hover:text-white border border-white/10 rounded-lg ml-1"
                  data-testid="mobile-menu-trigger"
                  aria-label="Open menu"
                >
                  <List size={20} />
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-sm text-zinc-300 hover:text-white px-3 sm:px-4 py-2 min-h-[44px] inline-flex items-center" data-testid="nav-login">Login</Link>
                <Link to="/signup" className="text-sm bg-blue-600 hover:bg-blue-700 text-white font-medium px-3 sm:px-4 py-2 min-h-[44px] rounded-lg transition-colors inline-flex items-center" data-testid="nav-signup">Get Started</Link>
              </>
            )}
          </div>
        </div>
      </nav>
      {user && <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />}
    </>
  );
};
